export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    gender: null,
    eatingMeatOften: null,
    likeBetter2: null,
    hiccups: null,
    childrenUpTo18: null,
    alcoholConsumption: null,
  },
})
